import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
Vue.config.devtools = true;
// 常用方法挂在到VUE原型上
import base from '@/utils/base'
Object.keys(base).forEach(item => {
    Vue.prototype[item] = base[item]
})

// eslint-disable-next-line no-unused-vars
// import directives from '@/directives/index'
import mixins from '@/mixins/index'
import router from '@/router/index'
import store from '@/store/index'

Vue.mixin(mixins)
Vue.directive('throttle', { 
    inserted(el, binding) { 
        el.addEventListener('click', () => { 
            el.style.pointerEvents = 'none'; 
            if (!el.disabled) { 
                setTimeout(() => { 
                    el.style.pointerEvents = 'auto'; 
                }, binding.value || 2000); 
            } 
        }); 
    } 
});
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// 注册全局组件
const files = require.context('@/components',true,/index\.vue$/);
files.keys().forEach(item=>{
    const fileItem = files(item).default;
    // 如果组件内定义name 则需要全局引用的
    if(fileItem.name){
        Vue.component(fileItem.name,fileItem);
    }
});
new Vue({
    router,
    store,
    mounted() {},
    render: h => h(App)
}).$mount('#app')
